import React from "react"

function TransferItem(props) {
  const colorText = (type) => {
    if (type === "ADD") {
      return "green"
    } else {
      return "red"
    }
  }
  const isPositive = (type) => {
    if (type === "ADD") {
      return "+"
    } else {
      return "-"
    }
  }
  return (
    <div className="transfer-item">
      <div className="flex justify-content-between align-items-center w-full">
        <div>
          <div className="flex flex-column">
            <div className="text-xs">{props.date}</div>
            <div className="text-xs">{props.description}</div>
          </div>
        </div>
        <p
          className="text-sm m-0 w-6rem text-right"
          style={{ color: colorText(props.type) }}
        >
          {isPositive(props.type)}
          {props.amount} pts
        </p>
      </div>
    </div>
  )
}

export default TransferItem
